var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      ref: "inputDate",
      attrs: {
        "offset-y": "",
        width: "290px",
        transition: "scale-transition",
        disabled: _vm.disabled,
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on }) {
            return [
              _c(
                "v-text-field",
                _vm._g(
                  {
                    ref: "textfielddata",
                    staticClass: "centered-input mx-2 date-input",
                    class: _vm.leftAlignInput ? "" : "centered-input",
                    attrs: {
                      label: _vm.label,
                      color: _vm.colordate,
                      readonly: "",
                    },
                    nativeOn: {
                      keyup: [
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "left", 37, $event.key, [
                              "Left",
                              "ArrowLeft",
                            ])
                          )
                            return null
                          if ("button" in $event && $event.button !== 0)
                            return null
                          return _vm.addDate(-1)
                        },
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "right", 39, $event.key, [
                              "Right",
                              "ArrowRight",
                            ])
                          )
                            return null
                          if ("button" in $event && $event.button !== 2)
                            return null
                          return _vm.addDate(1)
                        },
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "up", 38, $event.key, [
                              "Up",
                              "ArrowUp",
                            ])
                          )
                            return null
                          return _vm.addMonth(1)
                        },
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "down", 40, $event.key, [
                              "Down",
                              "ArrowDown",
                            ])
                          )
                            return null
                          return _vm.addMonth(-1)
                        },
                      ],
                    },
                    model: {
                      value: _vm.dateFormatted,
                      callback: function ($$v) {
                        _vm.dateFormatted = $$v
                      },
                      expression: "dateFormatted",
                    },
                  },
                  on
                ),
                [
                  _c(
                    "template",
                    { slot: "prepend-inner" },
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "", color: "primary" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on }) {
                                  return [
                                    _c(
                                      "v-icon",
                                      _vm._g(
                                        {
                                          style: { cursor: "pointer" },
                                          attrs: { large: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.addDate(-1)
                                            },
                                          },
                                        },
                                        on
                                      ),
                                      [_vm._v("mdi-arrow-left")]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _vm.format == "date"
                            ? _c("span", [_vm._v(_vm._s(_vm.$t("prevDay")))])
                            : _c("span", [_vm._v(_vm._s(_vm.$t("prevMonth")))]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "template",
                    { slot: "append" },
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "", color: "primary" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on }) {
                                  return [
                                    _c(
                                      "v-icon",
                                      _vm._g(
                                        {
                                          style: { cursor: "pointer" },
                                          attrs: { large: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.addDate(1)
                                            },
                                          },
                                        },
                                        on
                                      ),
                                      [_vm._v("mdi-arrow-right")]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _vm.format == "date"
                            ? _c("span", [_vm._v(_vm._s(_vm.$t("nextDay")))])
                            : _c("span", [_vm._v(_vm._s(_vm.$t("nextMonth")))]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
              _vm.format == "date" && _vm.showDayName
                ? _c(
                    "v-row",
                    {
                      attrs: {
                        justify: "center",
                        align: "center",
                        "no-gutters": "",
                      },
                    },
                    [
                      _c(
                        "p",
                        {
                          staticClass: "pa-0 ma-0",
                          staticStyle: { "font-size": "12px" },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm
                                  .$moment(_vm.mydate)
                                  .locale(_vm.$vuetify.lang.current)
                                  .format("dddd")
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm.format == "month" && _vm.showDayName
                ? _c(
                    "v-row",
                    {
                      attrs: {
                        justify: "center",
                        align: "center",
                        "no-gutters": "",
                      },
                    },
                    [
                      _c(
                        "p",
                        {
                          staticClass: "pa-0 ma-0",
                          staticStyle: { "font-size": "12px" },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm
                                  .$moment(_vm.mydate)
                                  .locale(_vm.$vuetify.lang.current)
                                  .format("MMMM")
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          },
        },
      ]),
      model: {
        value: _vm.Dialog,
        callback: function ($$v) {
          _vm.Dialog = $$v
        },
        expression: "Dialog",
      },
    },
    [
      _c(
        "v-overlay",
        { attrs: { value: _vm.loaderOverlay, absolute: true } },
        [
          _c(
            "v-row",
            { attrs: { justify: "center" } },
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", size: "64" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-card",
        { attrs: { color: _vm.colordate } },
        [
          _vm.textup != ""
            ? _c(
                "v-card-title",
                [
                  _c(
                    "v-layout",
                    {
                      attrs: {
                        "align-start": "",
                        "justify-center": "",
                        row: "",
                      },
                    },
                    [
                      _c("h2", { staticStyle: { color: "white" } }, [
                        _vm._v(_vm._s(_vm.textup)),
                      ]),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-card-text",
            { staticClass: "pa-1" },
            [
              _c(
                "v-date-picker",
                {
                  attrs: {
                    color: _vm.colordate,
                    min: _vm.min,
                    max: _vm.max,
                    events: _vm.functionEvents,
                    "allowed-dates": _vm.allowedDates,
                    width: "auto",
                    "first-day-of-week": 1,
                    locale: _vm.$vuetify.lang.current,
                    type: _vm.format,
                    "picker-date": _vm.pickerMonth,
                  },
                  on: {
                    input: function ($event) {
                      return _vm.closeDialog()
                    },
                    change: function ($event) {
                      return _vm.closeDialog()
                    },
                    "update:pickerDate": function ($event) {
                      _vm.pickerMonth = $event
                    },
                    "update:picker-date": function ($event) {
                      _vm.pickerMonth = $event
                    },
                  },
                  model: {
                    value: _vm.mydate,
                    callback: function ($$v) {
                      _vm.mydate = $$v
                    },
                    expression: "mydate",
                  },
                },
                [
                  _vm.userId != null
                    ? _c(
                        "v-container",
                        { staticClass: "pa-0" },
                        [
                          _c(
                            "v-row",
                            { attrs: { "no-gutters": "" } },
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c(
                                    "v-row",
                                    { attrs: { "no-gutters": "" } },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "2" } },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { color: "green" } },
                                            [_vm._v("mdi-circle-medium")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c("v-col", { attrs: { cols: "1" } }, [
                                        _vm._v(" " + _vm._s(" - ") + " "),
                                      ]),
                                      _c("v-col", { attrs: { cols: "9" } }, [
                                        _vm._v(
                                          " " + _vm._s(_vm.$t("workDay")) + " "
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    { attrs: { "no-gutters": "" } },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "2" } },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { color: "red" } },
                                            [_vm._v("mdi-circle-medium")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c("v-col", { attrs: { cols: "1" } }, [
                                        _vm._v(" " + _vm._s(" - ") + " "),
                                      ]),
                                      _c("v-col", { attrs: { cols: "9" } }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("publicHoliday")) +
                                            " "
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._l(_vm.absenceReasons, function (item) {
                                    return _c(
                                      "div",
                                      { key: item.id },
                                      [
                                        item.deleted == 0
                                          ? _c(
                                              "v-row",
                                              { attrs: { "no-gutters": "" } },
                                              [
                                                _c(
                                                  "v-col",
                                                  { attrs: { cols: "2" } },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          color: item.Farbcode,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "mdi-circle-medium"
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-col",
                                                  { attrs: { cols: "1" } },
                                                  [_vm._v(_vm._s(" - "))]
                                                ),
                                                _c(
                                                  "v-col",
                                                  { attrs: { cols: "9" } },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.$t(item.name))
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  }),
                                  _c(
                                    "v-row",
                                    { attrs: { "no-gutters": "" } },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "py-0",
                                          attrs: { cols: "12" },
                                        },
                                        [
                                          _c(
                                            "v-row",
                                            {
                                              staticStyle: {
                                                "justify-content": "flex-end",
                                              },
                                            },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: { text: "" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.closeDialog()
                                                    },
                                                  },
                                                },
                                                [_vm._v("OK")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }